<template>
  <div>
  
 <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
 
 
 
          
          
<!-- start officers -->



<div style="margin-top:100px"><h4 class="title">Officer Details</h4></div>

<card>
	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Position</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">
        	{{getOfficerPosition(officer.position)}}
      	  
        </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
     <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Title</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">
        	{{officer.title}}
      	  
        </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Status</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">
        {{officer.status_str}}
        </div>
        
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
     <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Date Of Appointment</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">
        <span v-if="officer.effective_date">
        {{officer.effective_date_str}}
        </span>
        <span v-else>None</span>
        
        </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


</card>

<div style="margin-top:30px"><h4 class="title">Person Details</h4></div>
<card class="form-horizontal">
			
       
	 <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Officer's Name</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{officer.first_name}} {{officer.last_name}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    

    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Address</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{officer.address_1}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >ID Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{officer.gov_id}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Nationality</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{getCountry(officer.nationality)}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
     <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Citizenship</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{getCitizenship(officer.citizenship)}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Email</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{officer.email}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Contact Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{officer.contact_num}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    

    
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Notes</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{officer.notes}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     

	<p-button v-if="0" type="danger"  @click="deleteOfficer(officer.id)" >
                <i slot="label" class="nc-icon nc-simple-remove"></i>
                <span style="text-decoration:line-through">Delete Officer </span>
     </p-button>

</card> 


<h4 style="font-weight:bold;">Actions</h4>
	<card>
		<p-button type="info"  @click="goToEditOfficer(officer.id)" >
				<i slot="label" class="nc-icon nc-settings-gear-65"></i>
                Edit Officer
        </p-button>
	
	</card>

    
    


<!-- end officers -->
   


  </div>
</template>
<script>
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  import {CommonService} from 'src/services/common.service'
  
  export default {
    components: {
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
     mounted() {
      	let uri = this.$base_url+'/api/v1/entities/'+ this.$route.params.eid;
     	 ApiService.get(uri).then(response => {      	    
      	    this.coy =  response.data.entity;
      	});
      	
      	
      	let o_uri = this.$base_url+'/api/v1/officers/'+ this.$route.params.oid+"/entity/"
     		+ this.$route.params.eid;
			 ApiService.get(o_uri).then(response => {
				
				this.officer = response.data.officer;
			    
			
			})
      	
      	
    },
    data () {
      return {
        activeName: 'first',
        enabledRadio: '2',
        coy:[],
        officer:[]
      }
    },
    methods:{
	  goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.$route.params.eid);
	  },
	  
	 getCitizenship(code){
      		
      		return CommonService.getCitizen(code);
      },
      getCountry(code){
      		
      		return CommonService.getCountry(code);
      },
      
      getOfficerPosition(code){
      		
      		return CommonService.getOfficerPosition(code);
      },

      goToEditOfficer($oid){
      	 this.$router.push( '/create-officer/'+this.$route.params.oid+'/entity/'+this.$route.params.eid)
      },
      

       deleteOfficer: function (oid) {
  
       	const vm = this;
       	
       	swal({
            title: 'Are you sure?',
            text: 'Officer will be deleted from all entities he/she is linked to.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes, delete it!',
            buttonsStyling: false
          }).then(function () {
             	const vm_ = vm;
          	 let uri = this.$base_url+'/api/v1/officers/delete/'+ oid;
     	  ApiService.get(uri).then(response => {
				swal({
				  title: 'Deleted!',
				  text: 'The officer has been deleted.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					 vm.$router.push( '/view-entity/'+vm.$route.params.eid);
				
				})
				//end swal
            })
         
            
          })
       }, //end deleteOfficer 

    },

    
  }
</script>
<style>

.cs_coy_detail_row{
	margin-top:25px;margin-bottom:25px;
}
.cs_coy_detail_label{
	font-weight:bold!important;
	color:#000!important;
	text-align:left!important;
}

 .cs_coy_detail_{
 	padding:10px 5px;
 	padding-left:20px;
 	border-bottom:1px dotted #000;
 }

</style>
